import API from "./api";

// GET DASHBOARD ANALYTICS
export const getDashboardAnalytics = async () => {
    try {

        const response = await API.get(
            "/admin/statics"
        );

        return response.data;

    } catch (error) {

        throw (
            error.response?.data || {
                message: "Failed to fetch dashboard data"
            }
        );

    }
};